require('./v-button');
module.exports = 'vButton';
